// @flow
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import * as React from "react";

type Props = {
  primary: React.Node,
  secondary?: React.Node,
  forwardRef?: any,
  classes?: Object,
};

function PageSubHeading({ primary, secondary, forwardRef, classes }: Props) {
  return (
    <Box mb={secondary ? 2 : 1} mt={4} ref={forwardRef}>
      <Typography variant="h5" component="h2">
        <b>{primary}</b>
      </Typography>
      {secondary && (
        <Box mt={0.5}>
          <Typography
            color="textSecondary"
            variant="body2"
            className={
              classes != null && classes.secondary != null
                ? classes.secondary
                : undefined
            }
          >
            {secondary}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default PageSubHeading;
